const constants = {
    SET_LOYALITY_OFFERS: 'SET_LOYALITY_OFFERS',
    SET_ENROLL_PROGRAM_SUCCESS: 'SET_ENROLL_PROGRAM_SUCCESS', 
}

export default constants;